function title(title) {
   return (document.title = title);
}
export default title;
